"use client";

import React from "react";
import { Key, ShieldCheck, Layers3 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
export default function ByoKeyClarityBox() {
  return <section id="byo-key-clarity-box" className="bg-background px-6 py-14 md:px-12 lg:py-16">
      <div className="mx-auto max-w-5xl">
        <Card className="rounded-2xl border border-primary/20 bg-primary/[0.04] shadow-[0_12px_30px_-15px_rgba(0,0,0,0.12)]">
          <CardContent className="flex flex-col gap-8 p-8 md:p-10 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-start gap-5">
              <div className="rounded-2xl bg-primary/10 p-4 shrink-0">
                <Key className="size-8 text-primary" strokeWidth={1.75} />
              </div>

              <div className="max-w-3xl">
                <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-background/70 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary">
                  <Layers3 className="size-3.5" />
                  BYO-Key clarity
                </div>

                <h2 className="text-2xl font-semibold tracking-tight text-foreground md:text-3xl">
                  Customers provide their own LLM and OCR keys
                </h2>

                <p className="mt-4 text-lg leading-relaxed text-muted-foreground">
                  EloRAG charges for the platform layer. LLM and OCR usage are billed directly by the
                  customer’s chosen providers, so variable AI costs stay separate from subscription pricing.
                </p>

                <div className="mt-5 grid grid-cols-1 gap-3 text-sm text-muted-foreground md:grid-cols-3">
                  <div className="rounded-lg border border-border/60 bg-background/70 px-4 py-3">
                    No bundled usage credits
                  </div>
                  <div className="rounded-lg border border-border/60 bg-background/70 px-4 py-3">
                    No fallback platform keys
                  </div>
                  <div className="rounded-lg border border-border/60 bg-background/70 px-4 py-3">
                    Clearer variable cost control
                  </div>
                </div>

                <div className="mt-5 inline-flex items-center gap-2 rounded-lg bg-background/70 px-4 py-3 text-sm text-foreground border border-border/60">
                  <ShieldCheck className="size-4 text-primary" />
                  EloRAG sells the RAG platform. Providers bill the model usage.
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}